"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexHumboldt = void 0;
const log_1 = require("log");
const BackendBuilds_1 = require("./IndexProfileRequests/BackendBuilds");
const BackendChannels_1 = require("./IndexProfileRequests/BackendChannels");
const BackendChannelsV2_1 = require("./IndexProfileRequests/BackendChannelsV2");
const BackendEventRequests_1 = require("./IndexProfileRequests/BackendEventRequests");
const IndexBuilderRequests_1 = require("./IndexProfileRequests/IndexBuilderRequests");
const IndexProfileRequests_1 = require("./IndexProfileRequests/IndexProfileRequests");
const IndexProfilesList_1 = require("./IndexProfileRequests/IndexProfilesList");
const IndexUserRequests_1 = require("./IndexProfileRequests/IndexUserRequests");
const MatterRequests_1 = require("./IndexProfileRequests/MatterRequests");
const Paths_1 = require("./Paths");
const Utils_1 = require("./Utils");
class IndexHumboldt {
    constructor(arg, appInfo, isStaging = false, options) {
        this.options = {};
        this.forProfile = (uuid) => new IndexProfileRequests_1.IndexProfileRequests(this.getProfilesEndpointSession(), uuid, IndexHumboldt.appInfo);
        this.forUser = () => new IndexUserRequests_1.IndexUserRequests(this.getProfilesEndpointSession(), IndexHumboldt.appInfo);
        this.forBuilder = () => new IndexBuilderRequests_1.IndexBuilderRequests(this.getProfilesEndpointSession(), IndexHumboldt.appInfo);
        this.events = () => new BackendEventRequests_1.BackendEventRequests(IndexHumboldt.sessionOptions, IndexHumboldt.appInfo);
        this.channels = () => new BackendChannels_1.BackendChannelsRequests(IndexHumboldt.sessionOptions, IndexHumboldt.appInfo);
        this.channelsV2 = () => new BackendChannelsV2_1.BackendChannelsV2Requests(IndexHumboldt.sessionOptions, IndexHumboldt.appInfo);
        this.builds = () => new BackendBuilds_1.BackendBuildsRequests(IndexHumboldt.sessionOptions, IndexHumboldt.appInfo);
        this.forProfilesList = () => new IndexProfilesList_1.IndexProfilesListRequests(IndexHumboldt.sessionOptions, IndexHumboldt.appInfo);
        this.forMatter = (profileId) => new MatterRequests_1.MatterRequests(this.getProfilesEndpointSession(), profileId, IndexHumboldt.appInfo);
        this.getProfilesEndpointSession = () => (Object.assign(Object.assign({}, IndexHumboldt.sessionOptions), { baseUrl: this.options.deakoAdmin ? Paths_1.Constants.BACKEND_ENDPOINT_V2_ADMIN : Paths_1.Constants.BACKEND_ENDPOINT_V2 }));
        if (IndexHumboldt.instance) {
            return IndexHumboldt.instance;
        }
        IndexHumboldt.isStaging = isStaging;
        IndexHumboldt.sessionOptions = (0, Utils_1.isSession)(arg) ? arg : {
            accessToken: arg,
            baseUrl: IndexHumboldt.getEndpoint(),
        };
        IndexHumboldt.appInfo = appInfo;
        IndexHumboldt.instance = this;
        if (options !== undefined) {
            this.options = options;
        }
    }
}
exports.IndexHumboldt = IndexHumboldt;
IndexHumboldt.setCustomEndpoint = (endpoint) => {
    log_1.Log.info(`[IndexHumboldt] Setting custom backend endpoint: ${endpoint}`);
    IndexHumboldt.customEndpoint = endpoint;
    IndexHumboldt.setSessionOptions();
};
IndexHumboldt.clearCustomEndpoint = () => {
    log_1.Log.info("[IndexHumboldt] Clearing custom backend endpoint");
    IndexHumboldt.customEndpoint = undefined;
    IndexHumboldt.setSessionOptions();
};
IndexHumboldt.setStaging = (value) => {
    log_1.Log.info(`[IndexHumboldt] Setting staging to ${value}`);
    IndexHumboldt.isStaging = value;
    IndexHumboldt.setSessionOptions();
};
IndexHumboldt.setSessionOptions = () => {
    IndexHumboldt.sessionOptions = Object.assign(Object.assign({}, IndexHumboldt.sessionOptions), { baseUrl: IndexHumboldt.getEndpoint() });
};
IndexHumboldt.getEndpoint = () => {
    if (IndexHumboldt.customEndpoint) {
        return IndexHumboldt.customEndpoint;
    }
    if (IndexHumboldt.isStaging) {
        return Paths_1.Constants.BACKEND_STAGING_ENDPOINT;
    }
    return Paths_1.Constants.BACKEND_ENDPOINT;
};
//# sourceMappingURL=IndexHumboldt.js.map